<template>

	<transition name="slide-fade" mode="out-in">
			<section class="col-xs-12">
				<div class="container">
					<div class="row">
						<div class="col-xs-12">
							<!-- <ul class="breadcrumb">
								<li><a href="#">Inicio</a></li>
								<li><a href="#">Locutores</a></li>
								<li><a href="#">Flavio Florentin</a></li>
							</ul> -->
						</div>
						<div class="col-xs-12 npd block" v-if="loaded === 'true'">
							<article class="col-sm-12 col-md-9 desarrollo">
								<!-- <h4 v-if="post.author_meta !== undefined || post.author_meta !== null">
									{{ post.author_meta.display_name }}
								</h4> -->
								<h3 v-html="post.title.rendered"></h3>
								<p v-if="post.fechaconformato !== undefined ">{{ post.fechaconformato }}</p>

								<figure v-if="post.featured_image_src['full'][0]">
									<img v-bind:src="post.featured_image_src['full'][0]" alt="">
								</figure>
								<!-- <figure v-else>
									<img v-bind:src="'http://via.placeholder.com/1000x516/008AD2/dddddd?text='+post.title.rendered" alt="">
								</figure> -->


								<p v-html="post.content.rendered"></p>
								<div class="compartiren">
									<li><b>Compartir en</b></li>
									<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+post.link" target="_blank"><i class="fa fa-facebook"></i></a></li>
									<li><a v-bind:href="'https://twitter.com/share?url='+post.link+'&text='+post.title.rendered" target="_blank"><i class="fa fa-twitter"></i></a></li>
									<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+post.link"><i class="fa fa-whatsapp"></i></a></li>
								</div>
								<!-- <a href="#" class="btn gris">Volver a Novedades</a> -->
							</article>
							<aside class="hidden-xs hidden-sm col-md-3 sidebar">


								<h3>REFLEXIONES</h3>
								<router-link :to="{ name: 'cat', params: { name:'podcast' } }" class="todo">
									Ver todo >
								</router-link>
								<div class="col-xs-12 npd reflexiones__item" v-if="loaded_audio=='true'">
									<figure v-if="audio.better_featured_image!=null">
										<img v-bind:src="audio.better_featured_image.media_details.sizes['536x412'].source_url" alt="">
									</figure>
									<figure v-else>
										<img v-bind:src="'http://via.placeholder.com/536x412/008AD2/dddddd?text='+audio.title.rendered" alt="">
									</figure>
									<div class="reflexiones__title paused">
										<button class="reflexiones__player" v-bind:audio="audio.post_meta_fields._enclosure_mp3">
											<i class="icon play-mini"></i>
										</button>
										<h3 v-html="audio.title.rendered"></h3>
									</div>
								</div>

								<h3>ENCUESTA</h3>

								<div v-for="_encuesta in encuesta" class="col-xs-12 npd encuest__item" v-if="loaded_encuesta=='true'">
									<figure>
										<img v-if="_encuesta.poll.image !== ''" v-bind:src="_encuesta.poll.image" alt="" >
											<img v-else v-bind:src="theme_url+'/html/assets/img/encuesta.jpg'" alt="" >
										
									</figure>
									<div class="encuesta__datos" v-for="_encuesta in encuesta">
										<p>Tu opinion es muy importante</p>
										<h4>{{ _encuesta.poll.question }}</h4>
										<form action="/wp-json/wp/v2/poll/" method="post" class="wp-polls-form col-xs-12" >
											<input type="hidden" name="action" value="polls">
											<input type="hidden" name="view" value="process">
											<input type="hidden" name="poll_id" v-bind:value="_encuesta.poll.id">
											<div class="col-xs-12 input-item" v-for="rta in _encuesta.poll.answers">

												<input type="radio" v-bind:name="'poll_'+_encuesta.poll.id"  v-bind:id="'rta_'+rta.polla_qid+'_'+rta.polla_aid" v-bind:value="rta.polla_aid">

												<label @click="getEncuesta()" v-bind:for="'rta_'+rta.polla_qid+'_'+rta.polla_aid">{{ rta.polla_answers}}</label>
											</div>

										</form>
									</div>
								</div>

								<h3>NOVEDADES</h3>
								<div class="col-xs-12 npd novedades" v-if="loaded_randpost=='true'">
									<router-link :to="{ name: 'post', params: { name:randpost.slug }}">
										<figure v-if="randpost.better_featured_image!=null">
											<img v-bind:src="randpost.better_featured_image.media_details.sizes['536x412'].source_url" alt="">
										</figure>
										<figure v-else>
											<img v-bind:src="'http://via.placeholder.com/536x412/008AD2/dddddd?text='+randpost.title.rendered" alt="">
										</figure>
										<h3 v-html="randpost.title.rendered"></h3>
										<p v-html="randpost.excerpt.rendered"></p>
									</router-link>
								</div>
							</aside>
						</div>
					</div>
				</div>
			</section>
		</transition>
</template>

<script>
export default {

	mounted: function() {
		this.getPost();
		this.getEncuesta();
		this.getPostRand();
		this.getPodcastRand();
	},
	watch: {
		// call method if the route changes
		'$route': 'reInitialize'
	},
	data() {
		return {
			base_path: rtwp.base_path,
			pageTitle: rtwp.site_name,
			theme_url: rtwp.theme_url,
			post: {},
			audio: {},
			encuesta: {},
			randpost: {},
			loaded: 'false',
			loaded_audio: 'false',
			loaded_encuesta: 'false',
			loaded_randpost: 'false',
			pageTitle: '',
			key: this.$route.path,
		};
	},

	methods: {

		reInitialize: function() {
			this.getPost();
			this.getPodcastRand();
			this.getEncuesta();
			this.getPostRand();
		//and so on
		},
		getPost: function() {
			const vm = this;
			vm.$http.get( 'wp/v2/posts', {
				params: { slug: vm.$route.params.name }
			} )
			.then( ( res ) => {
				vm.post = res.data[0];
				vm.loaded = 'true';
				vm.$nextTick(function(){
					vm.pageTitle = vm.post.title.rendered;
					vm.$store.commit( 'rtChangeTitle', vm.pageTitle );
				});
			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${res}` );
			} );
		},
		getPodcastRand: function() {
			const vm = this;
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: 7,per_page:1, orderby:'rand' }
			} )
			.then( ( res ) => {
				vm.audio = res.data[0];
				vm.loaded_audio = 'true';
				vm.$nextTick(function(){
					init_attach();
					setTimeout(function(){
						jQuery('div.reflexiones__title').on('click','button.reflexiones__player', function(event) {
							event.preventDefault();
							var self=this;
							var audio=jQuery('#elementodeaudio');
							var estado=jQuery(self).parent().hasClass('paused');
							console.log(estado);
							if(estado!=true){
								jQuery('div.reflexiones__title').addClass('paused');
								jQuery(audio).trigger('pause');
							} else {
								jQuery(audio).prop('src',jQuery(self).attr('audio'));
								jQuery(self).parent().removeClass('paused');
								jQuery(audio).trigger('play');

							}
						});
					},500);
				});
			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${res}` );
			} );
		},
		getEncuesta: function() {
			const vm = this;
			vm.$http.get( 'wp/v2/poll/')
			.then( ( res ) => {
				// console.log(res.data);
				vm.encuesta = res.data;
				vm.loaded_encuesta = 'true';
				vm.$nextTick(function(){
					init_attach();
				});

			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${res}` );
			} );
		},
		getPostRand: function() {
			const vm = this;
			vm.$http.get( 'wp/v2/posts', {
				params: { per_page:1, orderby:'rand', categories_exclude:'7,19,21,35,36' }
			} )
			.then( ( res ) => {
				vm.randpost = res.data[0];
				vm.loaded_randpost = 'true';
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${res}` );
			} );
		},

	}
};
</script>



// WEBPACK FOOTER //
// post.vue?91ef3216